// import { useState, useEffect, useRef } from "react"
// import { Link } from "react-router-dom"
// import axios from "axios"
// import { baseUrl } from "../config/baseUrl"
// import empty from "../assets/images/empty-box.png"
// import Swal from "sweetalert2"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import {
//   faQuestionCircle,
//   faPlus,
//   faEdit,
//   faTrash,
//   faSearch,
// } from "@fortawesome/free-solid-svg-icons"
// import { toast } from "react-toastify"

// export default function QuestionList() {
//   const [questions, setQuestions] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [searchTerm, setSearchTerm] = useState("")
//   const [statusFilter, setStatusFilter] = useState("")
//   const [language, setLanguage] = useState("english")

//   useEffect(() => {
//     fetchQuestions()
//   }, [])

//   const fetchQuestions = async () => {
//     try {
//       setLoading(true)
//       const response = await axios.get(`${baseUrl}/question`, {
//         headers: {
//           Authorization: localStorage.getItem("token"),
//         },
//       })
//       setQuestions(response.data.data)
//     } catch (error) {
//       console.log("error", error)
//     } finally {
//       setLoading(false)
//     }
//   }

//   const handleStatus = async (id, currentStatus) => {
//     const newStatus = currentStatus === "active" ? "inactive" : "active";

//     try {
//       const response = await fetch(`${baseUrl}/question/status/${id}`, {
//         method: "PATCH",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: localStorage.getItem("token"),
//         },
//         body: JSON.stringify({ status: newStatus }),
//       });

//       if (!response.ok) {
//         throw new Error("Failed to update status");
//       }

//       const result = await response.json(); // optional, in case you need it

//       // Refresh question list
//       fetchQuestions();

//       Swal.fire({
//         title: "Status Changed!",
//         icon: "success",
//         draggable: true,
//       });
//     } catch (error) {
//       console.error("Error updating status:", error);
//       Swal.fire({
//         title: "Error!",
//         text: "Failed to update status",
//         icon: "error",
//       });
//     }
//   };


//   const handleDelete = async (id) => {
//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, delete it!",
//     })

//     if (result.isConfirmed) {
//       try {
//         await axios.delete(`${baseUrl}/question/${id}`, {
//           headers: {
//             Authorization: localStorage.getItem("token"),
//           },
//         })
//         fetchQuestions()
//         Swal.fire("Deleted!", "Question has been deleted.", "success")
//       } catch (error) {
//         Swal.fire("Error!", "Failed to delete question.", "error")
//       }
//     }
//   }

//   // Move the getQuestionText function above the filteredQuestions filter

//   // Helper function to get question text based on language
//   const getQuestionText = (question, lang) => {
//     if (lang === "english") {
//       return question?.question_english || question?.questions || ""
//     } else if (lang === "hindi") {
//       return question?.question_hindi || question?.questions || ""
//     } else if (lang === "bengali") {
//       return question?.question_bengali || question?.questions || ""
//     }
//     return question?.question_english || question?.questions || ""
//   }

//   // Helper function to get option text based on language and option letter
//   const getOptionText = (question, lang, option) => {
//     if (lang === "english") {
//       return question?.[`option_${option.toLowerCase()}_english`] || question?.[`option_${option.toLowerCase()}`] || ""
//     } else if (lang === "hindi") {
//       return question?.[`option_${option.toUpperCase()}_hindi`] || question?.[`option_${option.toLowerCase()}`] || ""
//     } else if (lang === "bengali") {
//       // Bengali options use numbers instead of letters
//       const optionMap = { a: "1", b: "2", c: "3", d: "4", e: "5" }
//       return (
//         question?.[`option_${optionMap[option.toLowerCase()]}_bengali`] ||
//         question?.[`option_${option.toLowerCase()}`] ||
//         ""
//       )
//     }
//     return question?.[`option_${option.toLowerCase()}_english`] || question?.[`option_${option.toLowerCase()}`] || ""
//   }

//   // Helper function to get correct answer
//   const getCorrectAnswer = (question) => {
//     return question?.correct_answer || question?.correctAnswer || ""
//   }

//   // Filter questions based on search term, status, and handle multilingual search
//   const [subjectFilter, setSubjectFilter] = useState("");
//   const filteredQuestions = questions.filter((question) => {
//     // Get the appropriate question text based on selected language
//     const questionText = getQuestionText(question, language)

//     const matchesSearch = questionText?.toLowerCase().includes(searchTerm.toLowerCase())
//     const matchesStatus = statusFilter === "" || question.status === statusFilter
//     const matchSubject = subjectFilter === "" || question.subject === subjectFilter
//     return matchesSearch && matchesStatus
//   })

//   const truncateText = (text, maxLength = 50) => {
//     return text.length > maxLength ? text.substring(0, maxLength) + "..." : text
//   }

//   // Helper function to get question text based on language
//   // const getQuestionText = (question, lang) => {
//   //   if (lang === "english") {
//   //     return question?.question_english || question?.questions || ""
//   //   } else if (lang === "hindi") {
//   //     return question?.question_hindi || question?.questions || ""
//   //   } else if (lang === "bengali") {
//   //     return question?.question_bengali || question?.questions || ""
//   //   }
//   //   return question?.question_english || question?.questions || ""
//   // }

//   // Helper function to get option text based on language and option letter
//   // const getOptionText = (question, lang, option) => {
//   //   if (lang === "english") {
//   //     return question?.[`option_${option.toLowerCase()}_english`] || question?.[`option_${option.toLowerCase()}`] || ""
//   //   } else if (lang === "hindi") {
//   //     return question?.[`option_${option.toUpperCase()}_hindi`] || question?.[`option_${option.toLowerCase()}`] || ""
//   //   } else if (lang === "bengali") {
//   //     // Bengali options use numbers instead of letters
//   //     const optionMap = { a: "1", b: "2", c: "3", d: "4", e: "5" }
//   //     return (
//   //       question?.[`option_${optionMap[option.toLowerCase()]}_bengali`] ||
//   //       question?.[`option_${option.toLowerCase()}`] ||
//   //       ""
//   //     )
//   //   }
//   //   return question?.[`option_${option.toLowerCase()}_english`] || question?.[`option_${option.toLowerCase()}`] || ""
//   // }

//   // Helper function to get correct answer
//   // const getCorrectAnswer = (question) => {
//   //   return question?.correct_answer || question?.correctAnswer || ""
//   // }
//   const fileInputRef = useRef(null);
//   const handleUploadFile = (e) => {
//     let file = e.target.files[0];
//     let postData = new FormData();
//     postData.append("file", file);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//     }
//     apiCall(postData);
//   };
//   let apiCall = async (file) => {
//     try {
//       let response = await axios({
//         method: "POST",
//         url: `${baseUrl}/question/upload-excel`,
//         data: file,
//         headers: {
//           Authorization: localStorage.getItem("token"),
//         },
//       });

//       if (response.data.status) {
//         fetchQuestions();
//         Swal.fire({
//           title: "Questions uploaded!",
//           icon: "success",
//           draggable: true,
//         });
//       } else {
//         toast.error("Failed To Upload Questions");
//       }
//     } catch (error) {
//       toast.error("Failed to Add Questions")
//       console.error("API call failed:", error);
//     }
//   };
//   return (
//     <>
//       <section className="main-sec">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-6">
//               <div className="dashboard-title">
//                 <h4 className="dash-head">
//                   <FontAwesomeIcon icon={faQuestionCircle} className="me-2" />
//                   Questions
//                 </h4>
//               </div>
//               <div className="custom-bredcump">
//                 <nav aria-label="breadcrumb">
//                   <ol className="breadcrumb">
//                     <li className="breadcrumb-item">
//                       <Link to="/">Dashboard</Link>
//                     </li>
//                     <li className="breadcrumb-item active" aria-current="page">
//                       Questions List
//                     </li>
//                   </ol>
//                 </nav>
//               </div>
//             </div>
//             <div className="col-lg-6 d-flex justify-content-end align-items-start">
//               <div class="d-flex align-items-center">
//                 <label
//                   for="fileUpload"
//                   className=" btn-primary me-2 mb-0 btn-add-question"
//                 >
//                   <i class="fa fa-upload me-1"></i>
//                   Bulk Upload
//                 </label>
//                 <input
//                   type="file"
//                   ref={fileInputRef}
//                   onChange={handleUploadFile}
//                   id="fileUpload"
//                   className="d-none"
//                 />
//               </div>
//               <Link
//                 to="/sample_questions.ods"
//                 download
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className=" btn-info text-white btn-add-question me-2 bg-info"
//               >
//                 <i class="fa fa-arrow-down me-1"></i>
//                 Download Format
//               </Link>
//               <Link to="create" className="btn-add-question">
//                 <FontAwesomeIcon icon={faPlus} className="me-2" />
//                 Add Question
//               </Link>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-lg-12">
//               <div className="cards bus-list">
//                 <div className="bus-filter">
//                   <div className="row align-items-center">
//                     <div className="col-lg-6">
//                       <h5 className="card-title">Questions List ({filteredQuestions.length})</h5>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="search-filter-container">
//                   <div className="search-container">
//                     <FontAwesomeIcon icon={faSearch} className="search-icon" />
//                     <input
//                       type="text"
//                       className="search-input"
//                       placeholder="Search questions..."
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                     />
//                   </div>
//                   <select
//                     className="status-filter"
//                     value={statusFilter}
//                     onChange={(e) => setStatusFilter(e.target.value)}
//                   >
//                     <option value="">All Status</option>
//                     <option value="active">Active</option>
//                     <option value="inactive">Inactive</option>
//                   </select>
//                   <select className="status-filter" value={language} onChange={(e) => setLanguage(e.target.value)}>
//                     <option value="english">English</option>
//                     <option value="hindi">Hindi</option>
//                     <option value="bengali">Bengali</option>
//                   </select>
//                 </div>

//                 <div className="table-responsive custom-table">
//                   <table className="table table-borderless">
//                     <thead>
//                       <tr>
//                         <th>SN</th>
//                         <th>Question</th>
//                         {/* <th>Options</th> */}
//                         <th>Subject</th>
//                         <th>Topic</th>
//                         <th>Status</th>
//                         <th>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {loading ? (
//                         <tr>
//                           <td colSpan="6" className="loading-spinner">
//                             <div className="spinner"></div>
//                           </td>
//                         </tr>
//                       ) : filteredQuestions.length === 0 ? (
//                         <tr>
//                           <td colSpan="6" className="empty-state">
//                             <img src={empty || "/placeholder.svg"} alt="No questions" width="200px" />
//                             <h4>No Questions found!</h4>
//                             <p className="text-muted">
//                               {searchTerm || statusFilter
//                                 ? "Try adjusting your search or filter criteria"
//                                 : "Start by adding your first question"}
//                             </p>
//                           </td>
//                         </tr>
//                       ) : (
//                         filteredQuestions.map((question, i) => (
//                           <tr key={question?._id}>
//                             <td>{i + 1}</td>
//                             <td>
//                               <div className="question-text">
//                                 {truncateText(getQuestionText(question, language), 60)}
//                               </div>
//                             </td>
//                             {/* <td>
//                               <div className="options-container">
//                                 <div
//                                   className={`option-item ${getCorrectAnswer(question) === "A" ? "correct-answer" : ""}`}
//                                 >
//                                   A. {truncateText(getOptionText(question, language, "a"), 30)}
//                                 </div>
//                                 <div
//                                   className={`option-item ${getCorrectAnswer(question) === "B" ? "correct-answer" : ""}`}
//                                 >
//                                   B. {truncateText(getOptionText(question, language, "b"), 30)}
//                                 </div>
//                                 <div
//                                   className={`option-item ${getCorrectAnswer(question) === "C" ? "correct-answer" : ""}`}
//                                 >
//                                   C. {truncateText(getOptionText(question, language, "c"), 30)}
//                                 </div>
//                                 <div
//                                   className={`option-item ${getCorrectAnswer(question) === "D" ? "correct-answer" : ""}`}
//                                 >
//                                   D. {truncateText(getOptionText(question, language, "d"), 30)}
//                                 </div>
//                               </div>
//                             </td> */}
//                             <td>
//                               {question?.subject}
//                             </td>
//                             <td>
//                               {question?.topic}
//                             </td>
//                             <td>
//                               <button
//                                 onClick={() => handleStatus(question?._id, question?.status)}
//                                 className={`status-badge ${question.status === "active" ? "status-active" : "status-inactive"
//                                   }`}
//                               >
//                                 {question?.status === "active" ? (
//                                   <>

//                                     Active
//                                   </>
//                                 ) : (
//                                   <>

//                                     Inactive
//                                   </>
//                                 )}
//                               </button>
//                             </td>
//                             <td>
//                               <div className="action-buttons">
//                                 {/* <Link to={`/questions/view/${question?._id}`} className="action-btn view-btn">
//                                   <FontAwesomeIcon icon={faEye} />
//                                   <span className="tooltip-text">View</span>
//                                 </Link> */}
//                                 <Link to={`/questions/edit/${question?._id}`} className="action-btn edit-btn">
//                                   <FontAwesomeIcon icon={faEdit} />
//                                   <span className="tooltip-text">Edit</span>
//                                 </Link>
//                                 <button className="action-btn delete-btn" onClick={() => handleDelete(question?._id)}>
//                                   <FontAwesomeIcon icon={faTrash} />
//                                   <span className="tooltip-text">Delete</span>
//                                 </button>
//                               </div>
//                             </td>
//                           </tr>
//                         ))
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   )
// }



















// "use client"

// import { useState, useEffect, useRef } from "react"
// import { Link } from "react-router-dom"
// import axios from "axios"
// import { baseUrl } from "../config/baseUrl"
// import empty from "../assets/images/empty-box.png"
// import Swal from "sweetalert2"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import { faQuestionCircle, faPlus, faEdit, faTrash, faSearch, faEye } from "@fortawesome/free-solid-svg-icons"
// import { toast } from "react-toastify"

// export default function QuestionList() {
//   const [questions, setQuestions] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [searchTerm, setSearchTerm] = useState("")
//   const [statusFilter, setStatusFilter] = useState("")
//   const [subjectFilter, setSubjectFilter] = useState("")
//   const [language, setLanguage] = useState("english")
//   const [currentPage, setCurrentPage] = useState(1)
//   const [questionsPerPage] = useState(10)
//   const fileInputRef = useRef(null)

//   // Get unique subjects for filter
//   const uniqueSubjects = [...new Set(questions.map((q) => q.subject).filter(Boolean))]

//   useEffect(() => {
//     fetchQuestions()
//   }, [])

//   const fetchQuestions = async () => {
//     try {
//       setLoading(true)
//       const response = await axios.get(`${baseUrl}/question`, {
//         headers: {
//           Authorization: localStorage.getItem("token"),
//         },
//       })

//       if (response.data.status && Array.isArray(response.data.data)) {
//         setQuestions(response.data.data)
//       } else {
//         setQuestions([])
//         console.warn("Unexpected API response structure:", response.data)
//       }
//     } catch (error) {
//       console.error("Error fetching questions:", error)
//       toast.error("Failed to fetch questions")
//       setQuestions([])
//     } finally {
//       setLoading(false)
//     }
//   }

//   const handleStatus = async (id, currentStatus) => {
//     const newStatus = currentStatus === "active" ? "inactive" : "active"

//     try {
//       const response = await fetch(`${baseUrl}/question/status/${id}`, {
//         method: "PATCH",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: localStorage.getItem("token"),
//         },
//         body: JSON.stringify({ status: newStatus }),
//       })

//       if (!response.ok) {
//         throw new Error("Failed to update status")
//       }

//       // Update local state immediately for better UX
//       setQuestions((prevQuestions) => prevQuestions.map((q) => (q._id === id ? { ...q, status: newStatus } : q)))
//       toast.success("Status updated successfully")
//     } catch (error) {
//       console.error("Error updating status:", error)
//       Swal.fire({
//         title: "Error!",
//         text: "Failed to update status",
//         icon: "error",
//       })
//     }
//   }

//   const handleDelete = async (id) => {
//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, delete it!",
//     })

//     if (result.isConfirmed) {
//       try {
//         await axios.delete(`${baseUrl}/question/${id}`, {
//           headers: {
//             Authorization: localStorage.getItem("token"),
//           },
//         })

//         // Update local state immediately
//         setQuestions((prevQuestions) => prevQuestions.filter((q) => q._id !== id))

//         Swal.fire("Deleted!", "Question has been deleted.", "success")
//       } catch (error) {
//         console.error("Error deleting question:", error)
//         Swal.fire("Error!", "Failed to delete question.", "error")
//       }
//     }
//   }

//   // Helper function to get question text based on language
//   const getQuestionText = (question, lang) => {
//     if (!question) return ""

//     switch (lang) {
//       case "english":
//         return question.question_english || question.questions || ""
//       case "hindi":
//         return question.question_hindi || question.questions || ""
//       case "bengali":
//         return question.question_bengali || question.questions || ""
//       default:
//         return question.question_english || question.questions || ""
//     }
//   }

//   // Helper function to get option text based on language and option letter
//   const getOptionText = (question, lang, option) => {
//     if (!question) return ""

//     const optionLower = option.toLowerCase()
//     const optionUpper = option.toUpperCase()

//     switch (lang) {
//       case "english":
//         return question[`option_${optionLower}_english`] || question[`option_${optionLower}`] || ""
//       case "hindi":
//         return question[`option_${optionUpper}_hindi`] || question[`option_${optionLower}`] || ""
//       case "bengali":
//         // Bengali options use numbers instead of letters
//         const optionMap = { a: "1", b: "2", c: "3", d: "4", e: "5" }
//         return question[`option_${optionMap[optionLower]}_bengali`] || question[`option_${optionLower}`] || ""
//       default:
//         return question[`option_${optionLower}_english`] || question[`option_${optionLower}`] || ""
//     }
//   }

//   // Helper function to get explanation based on language
//   const getExplanation = (question, lang) => {
//     if (!question) return ""

//     switch (lang) {
//       case "english":
//         return question.explanation_english || question.explanation || ""
//       case "hindi":
//         return question.explanation_hindi || question.explanation || ""
//       case "bengali":
//         return question.explanation_bengali || question.explanation || ""
//       default:
//         return question.explanation_english || question.explanation || ""
//     }
//   }

//   // Helper function to get correct answer
//   const getCorrectAnswer = (question) => {
//     return question?.correct_answer || question?.correctAnswer || ""
//   }

//   // Filter questions based on search term, status, subject, and handle multilingual search
//   const filteredQuestions = questions.filter((question) => {
//     const questionText = getQuestionText(question, language)
//     const subject = question.subject || ""
//     const topic = question.topic || ""

//     const matchesSearch =
//       questionText.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       subject.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       topic.toLowerCase().includes(searchTerm.toLowerCase())

//     const matchesStatus = statusFilter === "" || question.status === statusFilter
//     const matchesSubject = subjectFilter === "" || question.subject === subjectFilter

//     return matchesSearch && matchesStatus && matchesSubject
//   })

//   // Pagination logic
//   const indexOfLastQuestion = currentPage * questionsPerPage
//   const indexOfFirstQuestion = indexOfLastQuestion - questionsPerPage
//   const currentQuestions = filteredQuestions.slice(indexOfFirstQuestion, indexOfLastQuestion)
//   const totalPages = Math.ceil(filteredQuestions.length / questionsPerPage)

//   const paginate = (pageNumber) => setCurrentPage(pageNumber)

//   const truncateText = (text, maxLength = 50) => {
//     if (!text) return ""
//     return text.length > maxLength ? text.substring(0, maxLength) + "..." : text
//   }

//   const handleUploadFile = (e) => {
//     const file = e.target.files[0]
//     if (!file) return

//     const postData = new FormData()
//     postData.append("file", file)

//     if (fileInputRef.current) {
//       fileInputRef.current.value = ""
//     }

//     apiCall(postData)
//   }

//   const apiCall = async (file) => {
//     try {
//       setLoading(true)
//       const response = await axios({
//         method: "POST",
//         url: `${baseUrl}/question/upload-excel`,
//         data: file,
//         headers: {
//           Authorization: localStorage.getItem("token"),
//         },
//       })

//       if (response.data.status) {
//         await fetchQuestions()
//         Swal.fire({
//           title: "Questions uploaded!",
//           text: `Successfully uploaded ${response.data.count || "multiple"} questions`,
//           icon: "success",
//           timer: 3000,
//           showConfirmButton: false,
//         })
//       } else {
//         toast.error(response.data.message || "Failed to upload questions")
//       }
//     } catch (error) {
//       console.error("Upload error:", error)
//       toast.error("Failed to upload questions")
//     } finally {
//       setLoading(false)
//     }
//   }

//   // Reset pagination when filters change
//   useEffect(() => {
//     setCurrentPage(1)
//   }, [searchTerm, statusFilter, subjectFilter, language])

//   return (
//     <>
//       <section className="main-sec">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-6">
//               <div className="dashboard-title">
//                 <h4 className="dash-head">
//                   <FontAwesomeIcon icon={faQuestionCircle} className="me-2" />
//                   Questions Management
//                 </h4>
//               </div>
//               <div className="custom-bredcump">
//                 <nav aria-label="breadcrumb">
//                   <ol className="breadcrumb">
//                     <li className="breadcrumb-item">
//                       <Link to="/">Dashboard</Link>
//                     </li>
//                     <li className="breadcrumb-item active" aria-current="page">
//                       Questions List
//                     </li>
//                   </ol>
//                 </nav>
//               </div>
//             </div>
//             <div className="col-lg-6 d-flex justify-content-end align-items-start">
//               <div className="d-flex align-items-center">
//                 <label htmlFor="fileUpload" className="btn-primary me-2 mb-0 btn-add-question">
//                   <i className="fa fa-upload me-1"></i>
//                   Bulk Upload
//                 </label>
//                 <input
//                   type="file"
//                   ref={fileInputRef}
//                   onChange={handleUploadFile}
//                   id="fileUpload"
//                   className="d-none"
//                   accept=".xlsx,.xls,.ods,.csv"
//                 />
//               </div>
//               <Link
//                 to="/sample_questions.ods"
//                 download
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="btn-info text-white btn-add-question me-2 bg-info"
//               >
//                 <i className="fa fa-arrow-down me-1"></i>
//                 Download Format
//               </Link>
//               <Link to="create" className="btn-add-question">
//                 <FontAwesomeIcon icon={faPlus} className="me-2" />
//                 Add Question
//               </Link>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-lg-12">
//               <div className="cards bus-list">
//                 <div className="bus-filter">
//                   <div className="row align-items-center">
//                     <div className="col-lg-6">
//                       <h5 className="card-title">
//                         Questions List ({filteredQuestions.length} of {questions.length})
//                       </h5>
//                     </div>
//                     <div className="col-lg-6 text-end">
//                       <small className="text-muted">
//                         Showing {indexOfFirstQuestion + 1}-{Math.min(indexOfLastQuestion, filteredQuestions.length)} of{" "}
//                         {filteredQuestions.length}
//                       </small>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="search-filter-container">
//                   <div className="row g-3">
//                     <div className="col-md-4">
//                       <div className="search-container">
//                         <FontAwesomeIcon icon={faSearch} className="search-icon" />
//                         <input
//                           type="text"
//                           className="search-input"
//                           placeholder="Search questions, subjects, topics..."
//                           value={searchTerm}
//                           onChange={(e) => setSearchTerm(e.target.value)}
//                         />
//                       </div>
//                     </div>
//                     <div className="col-md-2">
//                       <select
//                         className="status-filter"
//                         value={statusFilter}
//                         onChange={(e) => setStatusFilter(e.target.value)}
//                       >
//                         <option value="">All Status</option>
//                         <option value="active">Active</option>
//                         <option value="inactive">Inactive</option>
//                       </select>
//                     </div>
//                     <div className="col-md-3">
//                       <select
//                         className="status-filter"
//                         value={subjectFilter}
//                         onChange={(e) => setSubjectFilter(e.target.value)}
//                       >
//                         <option value="">All Subjects</option>
//                         {uniqueSubjects.map((subject) => (
//                           <option key={subject} value={subject}>
//                             {subject}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                     <div className="col-md-3">
//                       <select className="status-filter" value={language} onChange={(e) => setLanguage(e.target.value)}>
//                         <option value="english">English</option>
//                         <option value="hindi">हिंदी (Hindi)</option>
//                         <option value="bengali">বাংলা (Bengali)</option>
//                       </select>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="table-responsive custom-table">
//                   <table className="table table-borderless">
//                     <thead>
//                       <tr>
//                         <th>SN</th>
//                         <th>Question</th>
//                         <th>Subject</th>
//                         <th>Topic</th>
//                         <th>Correct Answer</th>
//                         <th>Status</th>
//                         <th>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {loading ? (
//                         <tr>
//                           <td colSpan="7" className="loading-spinner">
//                             <div className="spinner-border text-primary" role="status">
//                               <span className="visually-hidden">Loading...</span>
//                             </div>
//                             <p className="mt-2">Loading questions...</p>
//                           </td>
//                         </tr>
//                       ) : currentQuestions.length === 0 ? (
//                         <tr>
//                           <td colSpan="7" className="empty-state">
//                             <img src={empty || "/placeholder.svg"} alt="No questions" width="200px" />
//                             <h4>No Questions found!</h4>
//                             <p className="text-muted">
//                               {searchTerm || statusFilter || subjectFilter
//                                 ? "Try adjusting your search or filter criteria"
//                                 : "Start by adding your first question"}
//                             </p>
//                             {!searchTerm && !statusFilter && !subjectFilter && (
//                               <Link to="create" className="btn btn-primary mt-3">
//                                 <FontAwesomeIcon icon={faPlus} className="me-2" />
//                                 Add Your First Question
//                               </Link>
//                             )}
//                           </td>
//                         </tr>
//                       ) : (
//                         currentQuestions.map((question, i) => (
//                           <tr key={question?._id}>
//                             <td>{indexOfFirstQuestion + i + 1}</td>
//                             <td>
//                               <div className="question-text">
//                                 <div className="fw-medium">{truncateText(getQuestionText(question, language), 80)}</div>
//                                 {getExplanation(question, language) && (
//                                   <small className="text-muted d-block mt-1">Explanation available</small>
//                                 )}
//                               </div>
//                             </td>
//                             <td>
//                               <span className="badge bg-secondary">{question?.subject || "N/A"}</span>
//                             </td>
//                             <td>
//                               <span className="text-muted">{truncateText(question?.topic || "N/A", 30)}</span>
//                             </td>
//                             <td>
//                               <div className="correct-answer-display">
//                                 <span className="badge bg-success">{getCorrectAnswer(question)}</span>
//                                 <small className="d-block text-muted mt-1">
//                                   {truncateText(
//                                     getOptionText(question, language, getCorrectAnswer(question).toLowerCase()),
//                                     25,
//                                   )}
//                                 </small>
//                               </div>
//                             </td>
//                             <td>
//                               <button
//                                 onClick={() => handleStatus(question?._id, question?.status)}
//                                 className={`status-badge ${question.status === "active" ? "status-active" : "status-inactive"
//                                   }`}
//                                 disabled={loading}
//                               >
//                                 {question?.status === "active" ? "Active" : "Inactive"}
//                               </button>
//                             </td>
//                             <td>
//                               <div className="action-buttons">
//                                 <Link
//                                   to={`/questions/edit/${question?._id}`}
//                                   className="action-btn edit-btn"
//                                   title="Edit Question"
//                                 >
//                                   <FontAwesomeIcon icon={faEdit} />
//                                 </Link>
//                                 <button
//                                   className="action-btn delete-btn"
//                                   onClick={() => handleDelete(question?._id)}
//                                   title="Delete Question"
//                                   disabled={loading}
//                                 >
//                                   <FontAwesomeIcon icon={faTrash} />
//                                 </button>
//                               </div>
//                             </td>
//                           </tr>
//                         ))
//                       )}
//                     </tbody>
//                   </table>
//                 </div>

//                 {/* Pagination */}
//                 {totalPages > 1 && (
//                   <div className="pagination-container">
//                     <nav aria-label="Questions pagination">
//                       <ul className="pagination justify-content-center">
//                         <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
//                           <button
//                             className="page-link"
//                             onClick={() => paginate(currentPage - 1)}
//                             disabled={currentPage === 1}
//                           >
//                             Previous
//                           </button>
//                         </li>

//                         {[...Array(totalPages)].map((_, index) => {
//                           const pageNumber = index + 1
//                           // Show first page, last page, current page, and pages around current page
//                           if (
//                             pageNumber === 1 ||
//                             pageNumber === totalPages ||
//                             (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
//                           ) {
//                             return (
//                               <li
//                                 key={pageNumber}
//                                 className={`page-item ${currentPage === pageNumber ? "active" : ""}`}
//                               >
//                                 <button className="page-link" onClick={() => paginate(pageNumber)}>
//                                   {pageNumber}
//                                 </button>
//                               </li>
//                             )
//                           } else if (pageNumber === currentPage - 2 || pageNumber === currentPage + 2) {
//                             return (
//                               <li key={pageNumber} className="page-item disabled">
//                                 <span className="page-link">...</span>
//                               </li>
//                             )
//                           }
//                           return null
//                         })}

//                         <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
//                           <button
//                             className="page-link"
//                             onClick={() => paginate(currentPage + 1)}
//                             disabled={currentPage === totalPages}
//                           >
//                             Next
//                           </button>
//                         </li>
//                       </ul>
//                     </nav>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
      
//     </>
//   )
// }









// 19 JUNE 2025
"use client"

import { useState, useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import axios from "axios"
import { baseUrl } from "../config/baseUrl"
import empty from "../assets/images/empty-box.png"
import Swal from "sweetalert2"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faQuestionCircle, faPlus, faEdit, faTrash, faSearch } from "@fortawesome/free-solid-svg-icons"
import { toast } from "react-toastify"

export default function QuestionList() {
  const [questions, setQuestions] = useState([])
  const [subjects, setSubjects] = useState([])
  const [topics, setTopics] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchTerm, setSearchTerm] = useState("")
  const [statusFilter, setStatusFilter] = useState("")
  const [subjectFilter, setSubjectFilter] = useState("")
  const [topicFilter, setTopicFilter] = useState("")
  const [language, setLanguage] = useState("english")
  const [currentPage, setCurrentPage] = useState(1)
  const [questionsPerPage] = useState(10)
  const fileInputRef = useRef(null)

  useEffect(() => {
    fetchAllData()
  }, [])

  const fetchAllData = async () => {
    try {
      setLoading(true)

      // Fetch all data in parallel
      const [questionsResponse, subjectsResponse, topicsResponse] = await Promise.all([
        axios.get(`${baseUrl}/question`, {
          headers: { Authorization: localStorage.getItem("token") },
        }),
        axios.get(`${baseUrl}/subject/list`, {
          headers: { Authorization: localStorage.getItem("token") },
        }),
        axios.get(`${baseUrl}/topic/list`, {
          headers: { Authorization: localStorage.getItem("token") },
        }),
      ])

      // Set questions
      if (questionsResponse.data.status && Array.isArray(questionsResponse.data.data)) {
        setQuestions(questionsResponse.data.data)
      } else {
        setQuestions([])
        console.warn("Unexpected questions API response structure:", questionsResponse.data)
      }

      // Set subjects
      if (subjectsResponse.data && subjectsResponse.data.data && Array.isArray(subjectsResponse.data.data)) {
        setSubjects(subjectsResponse.data.data)
      } else {
        setSubjects([])
        console.warn("Unexpected subjects API response structure:", subjectsResponse.data)
      }

      // Set topics
      if (topicsResponse.data && topicsResponse.data.data && Array.isArray(topicsResponse.data.data)) {
        setTopics(topicsResponse.data.data)
      } else {
        setTopics([])
        console.warn("Unexpected topics API response structure:", topicsResponse.data)
      }
    } catch (error) {
      console.error("Error fetching data:", error)
      toast.error("Failed to fetch data")
      setQuestions([])
      setSubjects([])
      setTopics([])
    } finally {
      setLoading(false)
    }
  }

  // Helper function to get subject name by ID or name
  const getSubjectNameById = (subjectIdOrName) => {
    if (!subjectIdOrName) return "N/A"

    // If it's a MongoDB ObjectId (24 characters), find by ID
    if (typeof subjectIdOrName === "string" && subjectIdOrName.length === 24) {
      const subject = subjects.find((s) => s._id === subjectIdOrName)
      return subject ? subject.name : "Unknown Subject"
    }

    // If it's already a name (from bulk upload), return it directly
    return subjectIdOrName
  }

  // Helper function to get topic name by ID or name
  const getTopicNameById = (topicIdOrName) => {
    if (!topicIdOrName) return "N/A"

    // If it's a MongoDB ObjectId (24 characters), find by ID
    if (typeof topicIdOrName === "string" && topicIdOrName.length === 24) {
      const topic = topics.find((t) => t._id === topicIdOrName)
      return topic ? topic.name : "Unknown Topic"
    }

    // If it's already a name (from bulk upload), return it directly
    return topicIdOrName
  }

  // Get filtered topics based on selected subject
  const getFilteredTopics = () => {
    if (!subjectFilter) return topics
    return topics.filter((topic) => {
      // Handle both populated and non-populated topic subjects
      const topicSubjectId = topic.subject?._id || topic.subject
      return topicSubjectId === subjectFilter
    })
  }

  const handleStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active"

    try {
      const response = await fetch(`${baseUrl}/question/status/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
        body: JSON.stringify({ status: newStatus }),
      })

      if (!response.ok) {
        throw new Error("Failed to update status")
      }

      // Update local state immediately for better UX
      setQuestions((prevQuestions) => prevQuestions.map((q) => (q._id === id ? { ...q, status: newStatus } : q)))
      toast.success("Status updated successfully")
    } catch (error) {
      console.error("Error updating status:", error)
      Swal.fire({
        title: "Error!",
        text: "Failed to update status",
        icon: "error",
      })
    }
  }

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    })

    if (result.isConfirmed) {
      try {
        await axios.delete(`${baseUrl}/question/${id}`, {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        })

        // Update local state immediately
        setQuestions((prevQuestions) => prevQuestions.filter((q) => q._id !== id))

        Swal.fire("Deleted!", "Question has been deleted.", "success")
      } catch (error) {
        console.error("Error deleting question:", error)
        Swal.fire("Error!", "Failed to delete question.", "error")
      }
    }
  }

  // Helper function to get question text based on language
  const getQuestionText = (question, lang) => {
    if (!question) return ""

    switch (lang) {
      case "english":
        return question.question_english || question.questions || ""
      case "hindi":
        return question.question_hindi || question.questions || ""
      case "bengali":
        return question.question_bengali || question.questions || ""
      default:
        return question.question_english || question.questions || ""
    }
  }

  // Helper function to get option text based on language and option letter
  const getOptionText = (question, lang, option) => {
    if (!question) return ""

    const optionLower = option.toLowerCase()
    const optionUpper = option.toUpperCase()

    switch (lang) {
      case "english":
        return question[`option_${optionLower}_english`] || question[`option_${optionLower}`] || ""
      case "hindi":
        return question[`option_${optionUpper}_hindi`] || question[`option_${optionLower}`] || ""
      case "bengali":
        // Bengali options use numbers instead of letters
        const optionMap = { a: "1", b: "2", c: "3", d: "4", e: "5" }
        return question[`option_${optionMap[optionLower]}_bengali`] || question[`option_${optionLower}`] || ""
      default:
        return question[`option_${optionLower}_english`] || question[`option_${optionLower}`] || ""
    }
  }

  // Helper function to get explanation based on language
  const getExplanation = (question, lang) => {
    if (!question) return ""

    switch (lang) {
      case "english":
        return question.explanation_english || question.explanation || ""
      case "hindi":
        return question.explanation_hindi || question.explanation || ""
      case "bengali":
        return question.explanation_bengali || question.explanation || ""
      default:
        return question.explanation_english || question.explanation || ""
    }
  }

  // Helper function to get correct answer
  const getCorrectAnswer = (question) => {
    return question?.correct_answer || question?.correctAnswer || ""
  }

  // Get unique subjects for filter (include both ID-based and name-based)
  const getUniqueSubjects = () => {
    const subjectSet = new Set()

    questions.forEach((question) => {
      if (question.subject) {
        // If it's an ID, find the name
        if (question.subject.length === 24) {
          const subject = subjects.find((s) => s._id === question.subject)
          if (subject) {
            subjectSet.add(JSON.stringify({ id: subject._id, name: subject.name }))
          }
        } else {
          // If it's already a name, use it
          subjectSet.add(JSON.stringify({ id: question.subject, name: question.subject }))
        }
      }
    })

    return Array.from(subjectSet).map((item) => JSON.parse(item))
  }

  // Get unique topics for filter (include both ID-based and name-based)
  const getUniqueTopics = () => {
    const topicSet = new Set()

    questions.forEach((question) => {
      if (question.topic) {
        // If it's an ID, find the name
        if (question.topic.length === 24) {
          const topic = topics.find((t) => t._id === question.topic)
          if (topic) {
            topicSet.add(JSON.stringify({ id: topic._id, name: topic.name }))
          }
        } else {
          // If it's already a name, use it
          topicSet.add(JSON.stringify({ id: question.topic, name: question.topic }))
        }
      }
    })

    return Array.from(topicSet).map((item) => JSON.parse(item))
  }

  // Filter questions based on search term, status, subject, topic and handle multilingual search
  const filteredQuestions = questions.filter((question) => {
    const questionText = getQuestionText(question, language)
    const subjectName = getSubjectNameById(question.subject)
    const topicName = getTopicNameById(question.topic)

    const matchesSearch =
      questionText.toLowerCase().includes(searchTerm.toLowerCase()) ||
      subjectName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      topicName.toLowerCase().includes(searchTerm.toLowerCase())

    const matchesStatus = statusFilter === "" || question.status === statusFilter

    // Handle both ID and name matching for subject filter
    const matchesSubject =
      subjectFilter === "" ||
      question.subject === subjectFilter ||
      getSubjectNameById(question.subject) === getSubjectNameById(subjectFilter)

    // Handle both ID and name matching for topic filter
    const matchesTopic =
      topicFilter === "" ||
      question.topic === topicFilter ||
      getTopicNameById(question.topic) === getTopicNameById(topicFilter)

    return matchesSearch && matchesStatus && matchesSubject && matchesTopic
  })

  // Pagination logic
  const indexOfLastQuestion = currentPage * questionsPerPage
  const indexOfFirstQuestion = indexOfLastQuestion - questionsPerPage
  const currentQuestions = filteredQuestions.slice(indexOfFirstQuestion, indexOfLastQuestion)
  const totalPages = Math.ceil(filteredQuestions.length / questionsPerPage)

  const paginate = (pageNumber) => setCurrentPage(pageNumber)

  const truncateText = (text, maxLength = 50) => {
    if (!text) return ""
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text
  }

  const handleUploadFile = (e) => {
    const file = e.target.files[0]
    if (!file) return

    const postData = new FormData()
    postData.append("file", file)

    if (fileInputRef.current) {
      fileInputRef.current.value = ""
    }

    apiCall(postData)
  }

  const apiCall = async (file) => {
    try {
      setLoading(true)
      const response = await axios({
        method: "POST",
        url: `${baseUrl}/question/upload-excel`,
        data: file,
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })

      if (response.data.status) {
        await fetchAllData()
        Swal.fire({
          title: "Questions uploaded!",
          text: `Successfully uploaded ${response.data.count || "multiple"} questions`,
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
        })
      } else {
        toast.error(response.data.message || "Failed to upload questions")
      }
    } catch (error) {
      console.error("Upload error:", error)
      toast.error("Failed to upload questions")
    } finally {
      setLoading(false)
    }
  }

  // Reset pagination when filters change
  useEffect(() => {
    setCurrentPage(1)
  }, [searchTerm, statusFilter, subjectFilter, topicFilter, language])

  return (
    <>
      <section className="main-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="dashboard-title">
                <h4 className="dash-head">
                  <FontAwesomeIcon icon={faQuestionCircle} className="me-2" />
                  Questions Management
                </h4>
              </div>
              <div className="custom-bredcump">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Questions List
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <div className="col-lg-6 d-flex justify-content-end align-items-start">
              <div className="d-flex align-items-center">
                <label htmlFor="fileUpload" className="btn-primary me-2 mb-0 btn-add-question">
                  <i className="fa fa-upload me-1"></i>
                  Bulk Upload
                </label>
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleUploadFile}
                  id="fileUpload"
                  className="d-none"
                  accept=".xlsx,.xls,.ods,.csv"
                />
              </div>
              <Link
                to="/sample_questions.ods"
                download
                target="_blank"
                rel="noopener noreferrer"
                className="btn-info text-white btn-add-question me-2 bg-info"
              >
                <i className="fa fa-arrow-down me-1"></i>
                Download Format
              </Link>
              <Link to="create" className="btn-add-question">
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                Add Question
              </Link>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="cards bus-list">
                <div className="bus-filter">
                  <div className="row align-items-center">
                    <div className="col-lg-6">
                      <h5 className="card-title">
                        Questions List ({filteredQuestions.length} of {questions.length})
                      </h5>
                    </div>
                    <div className="col-lg-6 text-end">
                      <small className="text-muted">
                        Showing {indexOfFirstQuestion + 1}-{Math.min(indexOfLastQuestion, filteredQuestions.length)} of{" "}
                        {filteredQuestions.length}
                      </small>
                    </div>
                  </div>
                </div>

                <div className="search-filter-container">
                  <div className="row g-3">
                    <div className="col-md-3">
                      <div className="search-container">
                        <FontAwesomeIcon icon={faSearch} className="search-icon" />
                        <input
                          type="text"
                          className="search-input"
                          placeholder="Search questions, subjects, topics..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <select
                        className="status-filter"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                      >
                        <option value="">All Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <select
                        className="status-filter"
                        value={subjectFilter}
                        onChange={(e) => {
                          setSubjectFilter(e.target.value)
                          setTopicFilter("") // Reset topic when subject changes
                        }}
                      >
                        <option value="">All Subjects</option>
                        {getUniqueSubjects().map((subject, index) => (
                          <option key={index} value={subject.id}>
                            {subject.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-2">
                      <select
                        className="status-filter"
                        value={topicFilter}
                        onChange={(e) => setTopicFilter(e.target.value)}
                      >
                        <option value="">All Topics</option>
                        {getUniqueTopics().map((topic, index) => (
                          <option key={index} value={topic.id}>
                            {topic.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <select className="status-filter" value={language} onChange={(e) => setLanguage(e.target.value)}>
                        <option value="english">English</option>
                        <option value="hindi">हिंदी (Hindi)</option>
                        <option value="bengali">বাংলা (Bengali)</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="table-responsive custom-table">
                  <table className="table table-borderless">
                    <thead>
                      <tr>
                        <th>SN</th>
                        <th>Question</th>
                        <th>Subject</th>
                        <th>Topic</th>
                        <th>Correct Answer</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="7" className="loading-spinner">
                            <div className="spinner-border text-primary" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-2">Loading questions...</p>
                          </td>
                        </tr>
                      ) : currentQuestions.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="empty-state">
                            <img src={empty || "/placeholder.svg"} alt="No questions" width="200px" />
                            <h4>No Questions found!</h4>
                            <p className="text-muted">
                              {searchTerm || statusFilter || subjectFilter || topicFilter
                                ? "Try adjusting your search or filter criteria"
                                : "Start by adding your first question"}
                            </p>
                            {!searchTerm && !statusFilter && !subjectFilter && !topicFilter && (
                              <Link to="create" className="btn btn-primary mt-3">
                                <FontAwesomeIcon icon={faPlus} className="me-2" />
                                Add Your First Question
                              </Link>
                            )}
                          </td>
                        </tr>
                      ) : (
                        currentQuestions.map((question, i) => (
                          <tr key={question?._id}>
                            <td>{indexOfFirstQuestion + i + 1}</td>
                            <td>
                              <div className="question-text">
                                <div className="fw-medium">{truncateText(getQuestionText(question, language), 80)}</div>
                                {getExplanation(question, language) && (
                                  <small className="text-muted d-block mt-1">Explanation available</small>
                                )}
                              </div>
                            </td>
                            <td>
                              <span className="badge bg-secondary">{getSubjectNameById(question?.subject)}</span>
                            </td>
                            <td>
                              <span className="text-muted">{truncateText(getTopicNameById(question?.topic), 30)}</span>
                            </td>
                            <td>
                              <div className="correct-answer-display">
                                <span className="badge bg-success">{getCorrectAnswer(question)}</span>
                                <small className="d-block text-muted mt-1">
                                  {truncateText(
                                    getOptionText(question, language, getCorrectAnswer(question).toLowerCase()),
                                    25,
                                  )}
                                </small>
                              </div>
                            </td>
                            <td>
                              <button
                                onClick={() => handleStatus(question?._id, question?.status)}
                                className={`status-badge ${
                                  question.status === "active" ? "status-active" : "status-inactive"
                                }`}
                                disabled={loading}
                              >
                                {question?.status === "active" ? "Active" : "Inactive"}
                              </button>
                            </td>
                            <td>
                              <div className="action-buttons">
                                <Link
                                  to={`/questions/edit/${question?._id}`}
                                  className="action-btn edit-btn"
                                  title="Edit Question"
                                >
                                  <FontAwesomeIcon icon={faEdit} />
                                </Link>
                                <button
                                  className="action-btn delete-btn"
                                  onClick={() => handleDelete(question?._id)}
                                  title="Delete Question"
                                  disabled={loading}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div className="pagination-container">
                    <nav aria-label="Questions pagination">
                      <ul className="pagination justify-content-center">
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                          <button
                            className="page-link"
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                          >
                            Previous
                          </button>
                        </li>

                        {[...Array(totalPages)].map((_, index) => {
                          const pageNumber = index + 1
                          // Show first page, last page, current page, and pages around current page
                          if (
                            pageNumber === 1 ||
                            pageNumber === totalPages ||
                            (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
                          ) {
                            return (
                              <li
                                key={pageNumber}
                                className={`page-item ${currentPage === pageNumber ? "active" : ""}`}
                              >
                                <button className="page-link" onClick={() => paginate(pageNumber)}>
                                  {pageNumber}
                                </button>
                              </li>
                            )
                          } else if (pageNumber === currentPage - 2 || pageNumber === currentPage + 2) {
                            return (
                              <li key={pageNumber} className="page-item disabled">
                                <span className="page-link">...</span>
                              </li>
                            )
                          }
                          return null
                        })}

                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                          <button
                            className="page-link"
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}



















// "use client"

// import { useState, useEffect } from "react"
// import { Link } from "react-router-dom"
// import axios from "axios"
// import { baseUrl } from "../config/baseUrl"
// import empty from "../assets/images/empty-box.png"
// import Swal from "sweetalert2"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import {
//   faQuestionCircle,
//   faPlus,
//   faEye,
//   faEdit,
//   faTrash,
//   faCheck,
//   faTimes,
//   faSearch,
// } from "@fortawesome/free-solid-svg-icons"
// import { toast } from "react-toastify"
// import "react-toastify/dist/ReactToastify.css"

// export default function QuestionList() {
//   const [questions, setQuestions] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [searchTerm, setSearchTerm] = useState("")
//   const [statusFilter, setStatusFilter] = useState("")
//   const [subjects, setSubjects] = useState([])
//   const [topics, setTopics] = useState([])
//   const [subjectFilter, setSubjectFilter] = useState("")
//   const [topicFilter, setTopicFilter] = useState("")

//   useEffect(() => {
//     fetchQuestions()
//   }, [])

//   const fetchQuestions = async () => {
//     try {
//       setLoading(true)

//       // Fetch questions, subjects, and topics in parallel using the correct endpoints
//       const [questionsResponse, subjectsResponse, topicsResponse] = await Promise.all([
//         axios.get(`${baseUrl}/question`, {
//           headers: { Authorization: localStorage.getItem("token") },
//         }),
//         axios.get(`${baseUrl}/subject/list`, {
//           // Changed from /subject to /subject/list
//           headers: { Authorization: localStorage.getItem("token") },
//         }),
//         axios.get(`${baseUrl}/topic/list`, {
//           // Changed from /topic to /topic/list
//           headers: { Authorization: localStorage.getItem("token") },
//         }),
//       ])

//       if (questionsResponse.data.status && Array.isArray(questionsResponse.data.data)) {
//         setQuestions(questionsResponse.data.data)
//       } else {
//         setQuestions([])
//       }

//       if (subjectsResponse.data && subjectsResponse.data.data) {
//         setSubjects(subjectsResponse.data.data)
//       }

//       if (topicsResponse.data && topicsResponse.data.data) {
//         setTopics(topicsResponse.data.data)
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error)
//       toast.error("Failed to fetch questions")
//       setQuestions([])
//     } finally {
//       setLoading(false)
//     }
//   }

//   const handleStatus = async (id) => {
//     try {
//       await axios(`${baseUrl}/question/status/${id}`, {
//         method: "PATCH",
//         headers: {
//           Authorization: localStorage.getItem("token"),
//         },
//       })
//       fetchQuestions()
//       Swal.fire({
//         title: "Status Changed!",
//         text: "Question status updated successfully",
//         icon: "success",
//         draggable: true,
//       })
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: "Failed to update status",
//         icon: "error",
//       })
//     }
//   }

//   const handleDelete = async (id) => {
//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, delete it!",
//     })

//     if (result.isConfirmed) {
//       try {
//         await axios.delete(`${baseUrl}/question/${id}`, {
//           headers: {
//             Authorization: localStorage.getItem("token"),
//           },
//         })
//         fetchQuestions()
//         Swal.fire("Deleted!", "Question has been deleted.", "success")
//       } catch (error) {
//         Swal.fire("Error!", "Failed to delete question.", "error")
//       }
//     }
//   }

//   // Helper function to get subject name
//   const getSubjectName = (question) => {
//     if (!question.subject) return "N/A"

//     // If subject is already a string (old format), return it
//     if (typeof question.subject === "string" && question.subject.length < 30) {
//       return question.subject
//     }

//     // If subject is an ID, find the matching subject
//     const foundSubject = subjects.find((s) => s._id === question.subject)
//     return foundSubject ? foundSubject.name : "Unknown Subject" // Use .name instead of .name || .title
//   }

//   // Helper function to get topic name
//   const getTopicName = (question) => {
//     if (!question.topic) return "N/A"

//     // If topic is already a string (old format), return it
//     if (typeof question.topic === "string" && question.topic.length < 30) {
//       return question.topic
//     }

//     // If topic is an ID, find the matching topic
//     const foundTopic = topics.find((t) => t._id === question.topic)
//     return foundTopic ? foundTopic.name : "Unknown Topic" // Use .name instead of .name || .title
//   }

//   // Helper function to get question text
//   const getQuestionText = (question) => {
//     return question.question_english || question.question || question.questions || "No question text"
//   }

//   // Helper function to get option text
//   const getOptionText = (question, option) => {
//     const optionKey = `option_${option.toLowerCase()}_english`
//     const fallbackKey = `option${option}`
//     const simpleFallback = `option_${option.toLowerCase()}`

//     return question[optionKey] || question[fallbackKey] || question[simpleFallback] || `Option ${option}`
//   }

//   // Helper function to get correct answer
//   const getCorrectAnswer = (question) => {
//     return question.correct_answer || question.correctAnswer || "N/A"
//   }

//   const getFilteredTopics = () => {
//     if (!subjectFilter) return topics
//     return topics.filter((topic) => {
//       // Handle both populated and non-populated topic subjects
//       const topicSubjectId = topic.subject?._id || topic.subject
//       return topicSubjectId === subjectFilter
//     })
//   }

//   // Get unique subjects for filter - combine both name strings and resolved names
//   const uniqueSubjects = [...new Set(questions.map((q) => getSubjectName(q)).filter((name) => name !== "N/A"))]

//   // Filter questions based on search term and filters
//   const filteredQuestions = questions.filter((question) => {
//     const questionText = getQuestionText(question)
//     const subjectName = getSubjectName(question)
//     const topicName = getTopicName(question)

//     const matchesSearch =
//       questionText.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       subjectName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       topicName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       topicName.toLowerCase().includes(searchTerm.toLowerCase())

//     const matchesStatus = statusFilter === "" || question.status === statusFilter
//     const matchesSubject = subjectFilter === "" || subjectName === subjectFilter

//     return matchesSearch && matchesStatus && matchesSubject
//   })

//   const truncateText = (text, maxLength = 50) => {
//     if (!text) return ""
//     return text.length > maxLength ? text.substring(0, maxLength) + "..." : text
//   }

//   return (
//     <>
//       <style jsx>{`
//         .main-sec {
//           background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
//           min-height: 100vh;
//           padding: 2rem 0;
//         }

//         .dashboard-title {
//           margin-bottom: 1.5rem;
//         }

//         .dash-head {
//           color: #333;
//           font-size: 1.8rem;
//           font-weight: 700;
//           margin: 0;
//         }

//         .cards {
//           background: white;
//           border-radius: 15px;
//           padding: 2rem;
//           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//           margin-bottom: 2rem;
//         }

//         .bus-filter {
//           margin-bottom: 2rem;
//           padding-bottom: 1.5rem;
//           border-bottom: 1px solid #eee;
//         }

//         .card-title {
//           color: #333;
//           font-weight: 700;
//           margin: 0;
//         }

//         .btn-add-question {
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           border: none;
//           border-radius: 8px;
//           padding: 0.75rem 1.5rem;
//           color: white;
//           font-weight: 600;
//           text-decoration: none;
//           transition: all 0.3s ease;
//         }

//         .btn-add-question:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
//           color: white;
//         }

//         .search-filter-container {
//           display: flex;
//           gap: 1rem;
//           margin-bottom: 1.5rem;
//           flex-wrap: wrap;
//           align-items: center;
//         }

//         .search-input {
//           flex: 1;
//           min-width: 250px;
//           border-radius: 8px;
//           border: 1px solid #ddd;
//           padding: 0.75rem 1rem;
//           padding-left: 2.5rem;
//           position: relative;
//         }

//         .search-container {
//           flex: 2;
//           min-width: 250px;
//           position: relative;
//         }

//         .search-icon {
//           position: absolute;
//           left: 0.75rem;
//           top: 50%;
//           transform: translateY(-50%);
//           color: #999;
//         }

//         .status-filter {
//           flex: 1;
//           min-width: 120px;
//           border-radius: 8px;
//           border: 1px solid #ddd;
//           padding: 0.75rem 1rem;
//         }

//         .custom-table {
//           border-radius: 10px;
//           overflow: hidden;
//         }

//         .table {
//           margin: 0;
//         }

//         .table thead th {
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           color: white;
//           font-weight: 600;
//           border: none;
//           padding: 1rem;
//         }

//         .table tbody td {
//           padding: 1rem;
//           vertical-align: middle;
//           border-bottom: 1px solid #f0f0f0;
//         }

//         .table tbody tr:hover {
//           background-color: #f8f9ff;
//         }

//         .question-text {
//           max-width: 300px;
//           font-weight: 500;
//         }

//         .subject-topic-info {
//           font-size: 0.9rem;
//         }

//         .subject-name {
//           font-weight: 600;
//           color: #667eea;
//         }

//         .topic-name {
//           color: #666;
//           margin-top: 0.25rem;
//         }

//         .options-container {
//           display: flex;
//           flex-direction: column;
//           gap: 0.25rem;
//           font-size: 0.85rem;
//         }

//         .option-item {
//           padding: 0.25rem 0.5rem;
//           border-radius: 4px;
//           background: #f8f9fa;
//         }

//         .correct-answer {
//           background: #d4edda !important;
//           color: #155724;
//           font-weight: 600;
//           border: 1px solid #c3e6cb;
//         }

//         .status-badge {
//           padding: 0.5rem 1rem;
//           border-radius: 20px;
//           font-size: 0.85rem;
//           font-weight: 600;
//           border: none;
//           cursor: pointer;
//           transition: all 0.3s ease;
//         }

//         .status-active {
//           background: #d4edda;
//           color: #155724;
//         }

//         .status-inactive {
//           background: #f8d7da;
//           color: #721c24;
//         }

//         .status-badge:hover {
//           transform: scale(1.05);
//         }

//         .action-buttons {
//           display: flex;
//           gap: 0.5rem;
//         }

//         .action-btn {
//           width: 35px;
//           height: 35px;
//           border-radius: 8px;
//           border: none;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           position: relative;
//         }

//         .view-btn {
//           background: #4facfe;
//           color: white;
//         }

//         .edit-btn {
//           background: #ffa726;
//           color: white;
//         }

//         .delete-btn {
//           background: #ef5350;
//           color: white;
//         }

//         .action-btn:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
//         }

//         .tooltip-text {
//           position: absolute;
//           bottom: -30px;
//           left: 50%;
//           transform: translateX(-50%);
//           background: #333;
//           color: white;
//           padding: 0.25rem 0.5rem;
//           border-radius: 4px;
//           font-size: 0.75rem;
//           opacity: 0;
//           pointer-events: none;
//           transition: opacity 0.3s ease;
//           white-space: nowrap;
//         }

//         .action-btn:hover .tooltip-text {
//           opacity: 1;
//         }

//         .empty-state {
//           text-align: center;
//           padding: 3rem;
//         }

//         .empty-state img {
//           opacity: 0.7;
//           margin-bottom: 1rem;
//         }

//         .empty-state h4 {
//           color: #666;
//           margin-bottom: 1rem;
//         }

//         .loading-spinner {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           padding: 3rem;
//         }

//         .spinner {
//           width: 40px;
//           height: 40px;
//           border: 4px solid #f3f3f3;
//           border-top: 4px solid #667eea;
//           border-radius: 50%;
//           animation: spin 1s linear infinite;
//         }

//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }

//         @media (max-width: 768px) {
//           .search-filter-container {
//             flex-direction: column;
//           }
          
//           .search-container,
//           .status-filter {
//             min-width: 100%;
//           }
          
//           .table-responsive {
//             font-size: 0.85rem;
//           }
          
//           .question-text {
//             max-width: 200px;
//           }
          
//           .options-container {
//             font-size: 0.75rem;
//           }
//         }
//       `}</style>

//       <section className="main-sec">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-6">
//               <div className="dashboard-title">
//                 <h4 className="dash-head">
//                   <FontAwesomeIcon icon={faQuestionCircle} className="me-2" />
//                   Questions
//                 </h4>
//               </div>
//               <div className="custom-bredcump">
//                 <nav aria-label="breadcrumb">
//                   <ol className="breadcrumb">
//                     <li className="breadcrumb-item">
//                       <Link to="/">Dashboard</Link>
//                     </li>
//                     <li className="breadcrumb-item active" aria-current="page">
//                       Questions List
//                     </li>
//                   </ol>
//                 </nav>
//               </div>
//             </div>
//             <div className="col-lg-6 d-flex justify-content-end align-items-start">
//               <Link to="/questions/create" className="btn-add-question">
//                 <FontAwesomeIcon icon={faPlus} className="me-2" />
//                 Add Question
//               </Link>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-lg-12">
//               <div className="cards bus-list">
//                 <div className="bus-filter">
//                   <div className="row align-items-center">
//                     <div className="col-lg-6">
//                       <h5 className="card-title">Questions List ({filteredQuestions.length})</h5>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="search-filter-container">
//                   <div className="search-container">
//                     <FontAwesomeIcon icon={faSearch} className="search-icon" />
//                     <input
//                       type="text"
//                       className="search-input"
//                       placeholder="Search questions..."
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                     />
//                   </div>
//                   <select
//                     className="status-filter"
//                     value={statusFilter}
//                     onChange={(e) => setStatusFilter(e.target.value)}
//                   >
//                     <option value="">All Status</option>
//                     <option value="active">Active</option>
//                     <option value="inactive">Inactive</option>
//                   </select>
//                   <select
//                     className="status-filter"
//                     value={subjectFilter}
//                     onChange={(e) => {
//                       setSubjectFilter(e.target.value)
//                       setTopicFilter("") // Reset topic when subject changes
//                     }}
//                   >
//                     <option value="">All Subjects</option>
//                     {subjects.map((subject) => (
//                       <option key={subject._id} value={subject._id}>
//                         {subject.name} {/* Use .name instead of subject.name || subject.title */}
//                       </option>
//                     ))}
//                   </select>
//                   <select
//                     className="status-filter"
//                     value={topicFilter}
//                     onChange={(e) => setTopicFilter(e.target.value)}
//                     disabled={!subjectFilter}
//                   >
//                     <option value="">All Topics</option>
//                     {getFilteredTopics().map((topic) => (
//                       <option key={topic._id} value={topic._id}>
//                         {topic.name} {/* Use .name instead of topic.name || topic.title */}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div className="table-responsive custom-table">
//                   <table className="table table-borderless">
//                     <thead>
//                       <tr>
//                         <th>SN</th>
//                         <th>Question</th>
//                         <th>Subject & Topic</th>
//                         <th>Options</th>
//                         <th>Correct Answer</th>
//                         <th>Status</th>
//                         <th>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {loading ? (
//                         <tr>
//                           <td colSpan="7" className="loading-spinner">
//                             <div className="spinner"></div>
//                           </td>
//                         </tr>
//                       ) : filteredQuestions.length === 0 ? (
//                         <tr>
//                           <td colSpan="7" className="empty-state">
//                             <img src={empty || "/placeholder.svg"} alt="No questions" width="200px" />
//                             <h4>No Questions found!</h4>
//                             <p className="text-muted">
//                               {searchTerm || statusFilter || subjectFilter || topicFilter
//                                 ? "Try adjusting your search or filter criteria"
//                                 : "Start by adding your first question"}
//                             </p>
//                           </td>
//                         </tr>
//                       ) : (
//                         filteredQuestions.map((question, i) => (
//                           <tr key={question?._id}>
//                             <td>{i + 1}</td>
//                             <td>
//                               <div className="question-text">{truncateText(getQuestionText(question), 60)}</div>
//                             </td>
//                             <td>
//                               <div className="subject-topic-info">
//                                 <div className="subject-name">{getSubjectName(question)}</div>
//                                 <div className="topic-name">{getTopicName(question)}</div>
//                               </div>
//                             </td>
//                             <td>
//                               <div className="options-container">
//                                 <div
//                                   className={`option-item ${getCorrectAnswer(question) === "A" ? "correct-answer" : ""}`}
//                                 >
//                                   A. {truncateText(getOptionText(question, "A"), 30)}
//                                 </div>
//                                 <div
//                                   className={`option-item ${getCorrectAnswer(question) === "B" ? "correct-answer" : ""}`}
//                                 >
//                                   B. {truncateText(getOptionText(question, "B"), 30)}
//                                 </div>
//                                 <div
//                                   className={`option-item ${getCorrectAnswer(question) === "C" ? "correct-answer" : ""}`}
//                                 >
//                                   C. {truncateText(getOptionText(question, "C"), 30)}
//                                 </div>
//                                 <div
//                                   className={`option-item ${getCorrectAnswer(question) === "D" ? "correct-answer" : ""}`}
//                                 >
//                                   D. {truncateText(getOptionText(question, "D"), 30)}
//                                 </div>
//                               </div>
//                             </td>
//                             <td>
//                               <span className="badge bg-success">Option {getCorrectAnswer(question)}</span>
//                             </td>
//                             <td>
//                               <button
//                                 onClick={() => handleStatus(question?._id)}
//                                 className={`status-badge ${question.status === "active" ? "status-active" : "status-inactive"
//                                   }`}
//                               >
//                                 {question?.status === "active" ? (
//                                   <>
//                                     <FontAwesomeIcon icon={faCheck} className="me-1" />
//                                     Active
//                                   </>
//                                 ) : (
//                                   <>
//                                     <FontAwesomeIcon icon={faTimes} className="me-1" />
//                                     Inactive
//                                   </>
//                                 )}
//                               </button>
//                             </td>
//                             <td>
//                               <div className="action-buttons">
//                                 <Link to={`/questions/view/${question?._id}`} className="action-btn view-btn">
//                                   <FontAwesomeIcon icon={faEye} />
//                                   <span className="tooltip-text">View</span>
//                                 </Link>
//                                 <Link to={`/questions/edit/${question?._id}`} className="action-btn edit-btn">
//                                   <FontAwesomeIcon icon={faEdit} />
//                                   <span className="tooltip-text">Edit</span>
//                                 </Link>
//                                 <button className="action-btn delete-btn" onClick={() => handleDelete(question?._id)}>
//                                   <FontAwesomeIcon icon={faTrash} />
//                                   <span className="tooltip-text">Delete</span>
//                                 </button>
//                               </div>
//                             </td>
//                           </tr>
//                         ))
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   )
// }
